import * as React from "react";
import { Modal, Button, FormGroup, ControlLabel, Radio } from "react-bootstrap";

interface IProps {
    show: boolean,
    data: {
        chainId: number,
        clusterNumber: number,
        swapManager: string,
    },
    onSave: (updateAllClustersInChain: boolean) => void,
    onCancel: () => void
}

interface IState {
    applyTo: number
}

class SwapManagerChange extends React.Component<IProps, IState> {
    readonly state: IState = {
        applyTo: 0
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show) {
            this.setState({
                applyTo: 0
            });
        }
    }

    handleApplyToChange = (e: React.FormEvent<Radio & HTMLInputElement>) => {
        this.setState({
            applyTo: parseInt(e.currentTarget.value)
        });
    }

    handleSave = () => {
        this.props.onSave(this.state.applyTo == 1);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const swapManager = this.props.data.swapManager;

        return (
            <Modal show={this.props.show} onHide={this.handleCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Swap Manager - <span style={{ fontWeight: 700, color: "#133366" }}>Swap {this.props.data.chainId} / {this.props.data.clusterNumber}</span>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <FormGroup>
                        <ControlLabel>How do you want to apply this change to the swap manager ({swapManager})?</ControlLabel>
                        <Radio name="swapManagerChoice" style={{ marginLeft: 20 }} value={0} checked={this.state.applyTo == 0} onChange={this.handleApplyToChange}>Only to this cluster</Radio>
                        <Radio name="swapManagerChoice" style={{ marginLeft: 20 }} value={1} checked={this.state.applyTo == 1} onChange={this.handleApplyToChange}>To all clusters in the chain</Radio>
                    </FormGroup>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.handleSave}>Apply</Button>
                    <Button onClick={this.handleCancel}>Cancel Change</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SwapManagerChange;